import Styled from 'styled-components';

export interface IDividerProps {
  backgroundColor?: string;
  margin?: string;
}

export const VerticalDivider = Styled.div<IDividerProps>`
  display: flex;
  width: 1px;
  height: 100%;
  background-color: ${props => props.backgroundColor || props.theme.colorSlate10};
  margin: ${props => props.margin};
`;

VerticalDivider.defaultProps = {
  margin: '0',
};

VerticalDivider.displayName = 'VerticalDivider';
